"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const storage_1 = require("@civic/storage");
function getPublicProfileForDidDocument(didDocument) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const civicMeStorageAdapter = new storage_1.CivicMeAdapter(didDocument.id, 
        /** With the readonly view a function that returns the already resolved DID is sufficient.
         * when the profile library is enhanced to also facility write operations, then we will need
         * to plug in a resolve function here */
        () => Promise.resolve(didDocument), {
            publicRemoteProfile: {
                didAware: {
                    fragmentId: "publicRemoteProfile",
                    urlPrefix: "ipfs://",
                },
                encrypted: false,
                locationType: storage_1.LocationTypes.IPFS,
            },
        }, {
            "$.publicRemoteProfile": "publicRemoteProfile",
        });
        const jsonAdapter = new storage_1.JsonPathAdapter(civicMeStorageAdapter);
        const publicRemoteProfile = yield jsonAdapter.get("$.publicRemoteProfile");
        return publicRemoteProfile;
    });
}
exports.default = {
    getPublicProfileForDidDocument,
};
